<div class="dropdown container-fluid" [ngClass]="{ 'align-right': alignRight }">
  <form [formGroup]="filterForm">
    <div class="row flex justify-between">
      @for(item of filters; track $index){
      <div class="col-auto" [ngClass]="{'customer-name': item?.key === 'customerName'}">
        @switch (item?.type) { 
            @case ('dropdown') {
                <app-global-dropdown
                [formControlName]="item.key"
                [options]="options[item.key] || []"
                [data]="item"
                >
                </app-global-dropdown>
            } 
            @case ('slider-range') {
                <app-mat-slider [data]="item">                     
                </app-mat-slider>
            } 
             @case ('button') {
       <app-button
  [data]="item"
  [selectedKey]="selectedKey"
  (selectionChange)="onButtonSelectionChange($event)">
</app-button>

            } 
              @case ('icon') {
        <mat-icon (click)="download(item.apiUrl)" style="cursor:pointer;margin-top: 2.2rem;">download</mat-icon>
        }
            @case ('search') {
                <app-search-container
                    [data]="item"
                    (search)="onSearch($event, item.key)">
                </app-search-container>
            }
            @case ('input') {
                <!-- If this is the customer name field and we are on quote-parts, render read-only label:value -->
                @if(item?.key === 'customerName') {
                  <div class="filter-container customer-display-inline">
                    <span class="customer-inline-label">{{ item.name }}:&nbsp;</span>
                    <span class="customer-inline-value">{{ filterForm.get(item.key)?.value || '' }}</span>
                  </div>
                }
                @else {
                  <div class="filter-container input-filter">
                    <label class="filter-label">{{ item.name }}</label>
                    <mat-form-field appearance="outline" class="input-field">
                        <input matInput [formControlName]="item.key" [placeholder]="item.placeholder || ''">
                    </mat-form-field>
                  </div>
                }
            }

            @default {} 
          }
      </div>
      }
      <div class="col-auto mt-3" *ngIf="showResetButton">
        <div (click)="resetButton()" class="reset d-flex align-items-center" style="cursor: pointer;">
          <mat-icon class="material-symbols-outlined me-1">filter_alt</mat-icon>
          <span>RESET FILTERS</span>
        </div>
      </div>
    </div>
  </form>
</div>
